module.exports = __webpack_public_path__ + "images/hell-on-wheels-a0487ede27605dc704fd35ac2e4f793d.png";